import { action, computed } from 'easy-peasy'
import { APP_MODE } from '@v4/constants/general'
import { checkIsBuilderMode, checkIsScorecardMode } from '@v4/utils/general'

export const createGeneralModel = (initialData, component) => ({
	component,
	autoHeight: false,
	parentWindowHeight: 0,
	mode: initialData.mode || APP_MODE.scorecard,
	basename: initialData.base_url || '',
	isBuilderMode: computed(state => checkIsBuilderMode(state.mode)),
	isScorecardMode: computed(state => checkIsScorecardMode(state.mode)),
	targetWindow: (window && new URLSearchParams(window.location.search).get('sa_target')) || null,
	widgetKey: (window && new URLSearchParams(window.location.search).get('sa_widget')) || '',
	themeButtonVisible: false,

	setMode: action((state, payload) => {
		state.mode = payload
	}),

	setAutoHeight: action((state, payload) => {
		state.autoHeight = payload
	}),

	setThemeButtonVisible: action((state, payload) => {
		state.themeButtonVisible = payload
	}),

	setParentWindowHeight: action((state, payload) => {
		state.parentWindowHeight = payload || 0
	}),
})
